// extracted by mini-css-extract-plugin
module.exports = {"actionButtonsContainer":"ReferralSources_actionButtonsContainer__3BM0q","actionColumn":"ReferralSources_actionColumn__1SoT6","textButton":"ReferralSources_textButton__W5FJb"};